import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  transform(value: string, maxLength = 20): string {
    return value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
  }

}
